import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import React from 'react';
import Default from 'react-bootstrap/Anchor';

const LinkBase = /*#__PURE__*/ React.forwardRef(({ children, className, withHoverBg, size, variant = '', fixedWidth, as: _as, ...rest }, ref)=>{
    const sizeValue = size === 'md' ? undefined : size;
    return jsx(Default, {
        ref: ref,
        className: classNames('link', {
            'link-with-hover-bg': withHoverBg,
            'link-fixed-width': fixedWidth,
            [`link-${sizeValue}`]: sizeValue,
            [`link-${variant}`]: variant
        }, className),
        ...rest,
        children: children
    });
});

export { LinkBase };
